import type { Cin7Tax } from "@/api/dtos";
import type { Tax } from "@/api/tax/_models/Tax";
import { toTaxComponentFromCin7TaxComponent } from "./utils";

export const toTaxFromCin7Tax = (dto: Cin7Tax): Tax => {
  return {
    id: dto.ID,
    name: dto.Name,
    account: dto.Account,
    isActive: dto.IsActive,
    isInclusive: dto.TaxInclusive,
    taxPercent: dto.TaxPercent,
    isForSale: dto.IsTaxForSale,
    isForPurchase: dto.IsTaxForPurchase,
    components: dto.Components.map((x) => toTaxComponentFromCin7TaxComponent(x)),
  };
};
